function ProductCard({ product, qty, addToCart, decreaseQuantity }) {
  return (
    <div className="flex flex-col group border-b border-gray-100 sm:border sm:border-gray-100 sm:rounded-sm pb-6 sm:pb-0 overflow-hidden bg-white hover:shadow-xl transition-shadow duration-300">
      <div className="relative aspect-[4/3] sm:aspect-square bg-white p-6 sm:p-8 flex items-center justify-center overflow-hidden">
        <img
          src={product.image}
          alt={product.name}
          className="object-contain w-full h-full mix-blend-multiply sm:scale-95 group-hover:scale-100 transition-transform duration-500"
        />
      </div>
      
      <div className="p-4 sm:p-5 flex flex-col flex-grow border-t border-gray-50">
        <div className="text-[10px] text-gray-400 mb-1.5 uppercase font-bold tracking-widest">
          {product.category}
        </div>
        <h2 className="text-[15px] font-semibold text-gray-900 mb-1.5 line-clamp-2 leading-snug">{product.name}</h2>
        <p className="text-[13px] text-gray-500 mb-4 line-clamp-2 flex-grow leading-relaxed">{product.description}</p>
        
        <div className="flex items-end justify-between mt-auto">
          <div className="text-lg font-bold text-gray-900 tracking-tight">
            ${product.price.toLocaleString()}
          </div>
          
          {qty > 0 ? (
            <div className="flex items-center bg-gray-50 border border-gray-200 rounded-sm">
              <button
                onClick={() => decreaseQuantity(product._id)}
                className="w-8 h-8 flex items-center justify-center text-gray-500 hover:text-black hover:bg-gray-100 transition-colors"
                title="Decrease quantity"
              >
                -
              </button>
              <span className="w-8 text-center text-sm font-medium text-gray-900 select-none bg-white py-1">{qty}</span>
              <button
                onClick={() => addToCart(product)}
                className="w-8 h-8 flex items-center justify-center text-gray-500 hover:text-black hover:bg-gray-100 transition-colors"
                title="Increase quantity"
              >
                +
              </button>
            </div>
          ) : (
            <button
              onClick={() => addToCart(product)}
              className="bg-white border border-gray-300 text-gray-900 hover:border-black hover:bg-black hover:text-white px-4 py-1.5 text-[13px] font-medium rounded-sm transition-all"
            >
              Add to cart
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default ProductCard;
